// removed by extract-text-webpack-plugin
module.exports = {"divContainer":"divContainer--46cc5"};